/**
 * This sets defaults and handles maintaining our auth token/params
 * between http requests.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource);


const share = Vue.resource('shares{/id}');



export default share;



// WEBPACK FOOTER //
// ./src/resources/share.js